<template>
  <v-list dense>
    <v-list-tile>
      <v-list-tile-content>Key</v-list-tile-content>
      <v-list-tile-content class="align-end">Value</v-list-tile-content>
      <v-list-tile-avatar>Info</v-list-tile-avatar>
    </v-list-tile>
    <v-list-tile v-for="(k, i) in Object.keys(kvStore.Data)" :key="`row-${i}`">
      <v-list-tile-content>{{k}}</v-list-tile-content>
      <v-list-tile-content class="align-end">{{_calculateDisplayValue(kvStore.Data[k])}}</v-list-tile-content>
      <v-list-tile-avatar>
        <v-btn flat icon @click="handleShowInfo(k, kvStore.Data[k])">
          <v-icon>info</v-icon>
        </v-btn>
      </v-list-tile-avatar>
    </v-list-tile>
    <KVPairInfoModal :key="`metadata-info-${kvStore.Id}`" v-model="showInfo" :kvValue="showInfoKVValue" :kvPairKey="showInfoKVPairKey" />
  </v-list>
</template>

<script>
  import {
    calculateDisplayValue,
  } from '@/helpers/kvValueHelper'
  export default {
    props: {
      value: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        showInfo: false,
        showInfoKVPairKey: '',
        showInfoKVValue: {},
      }
    },
    computed: {
      kvStore() {
        return this.value
      },
    },
    methods: {
      handleShowInfo(kvPairKey, kvValue) {
        this.showInfoKVPairKey = kvPairKey
        this.showInfoKVValue = kvValue
        this.showInfo = true
      },
      _calculateDisplayValue(kvValue) {
        return calculateDisplayValue(kvValue)
      },
    },
  }
</script>